import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e253e82a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container px-5 py-4" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex position-fixed w-100 h-100 align-items-center justify-content-center",
  style: {"z-index":"100000","background-color":"rgba(255, 255, 255, 0.75)","left":"0px","top":"0px"}
}
const _hoisted_3 = { class: "d-block text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, null, -1))
const _hoisted_5 = { class: "text-center fw-bold pt-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-center fw-bold pt-3" }, [
  /*#__PURE__*/_createTextVNode(" Si sos usuario registrado iniciá sesión. Sino te invitamos"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("a registrarte o continuá como invitado ")
], -1))
const _hoisted_7 = { class: "text-center fw-bold pt-5" }
const _hoisted_8 = {
  key: 0,
  class: "text-center fw-bold pt-3"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = {
  key: 1,
  class: "text-center fw-bold pt-3"
}
const _hoisted_11 = {
  key: 2,
  class: "text-center fw-bold pt-3"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = {
  key: 3,
  class: "text-center fw-bold pt-3"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { class: "row mt-5 justify-content-center" }
const _hoisted_16 = {
  key: 0,
  class: "col-12 col-md-12 col-lg-6 d-flex justify-content-center"
}
const _hoisted_17 = { class: "card card_styled" }
const _hoisted_18 = { class: "card-title m-2" }
const _hoisted_19 = { class: "text-center fw-bold pt-2" }
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-md-12 mb-2" }
const _hoisted_23 = { class: "col-md-12" }
const _hoisted_24 = { class: "row mt-3" }
const _hoisted_25 = { class: "col-12 my-2" }
const _hoisted_26 = {
  key: 0,
  class: "col-12 my-2"
}
const _hoisted_27 = { class: "card-footer bg-white border-top-0 mb-2" }
const _hoisted_28 = { class: "col-12 col-md-12" }
const _hoisted_29 = {
  key: 1,
  class: "col-12 col-md-12 col-lg-6 d-flex justify-content-center my-3 my-lg-0"
}
const _hoisted_30 = { class: "card card_styled" }
const _hoisted_31 = {
  key: 0,
  class: "card-title m-2"
}
const _hoisted_32 = { class: "text-center fw-bold pt-2" }
const _hoisted_33 = {
  key: 1,
  class: "card-text m-2 p-2"
}
const _hoisted_34 = { class: "text-center fw-bold" }
const _hoisted_35 = { class: "card-body" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-md-12 mb-2" }
const _hoisted_38 = { class: "card-footer bg-white border-top-0 mb-2" }
const _hoisted_39 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInfoTitles = _resolveComponent("AppInfoTitles")!
  const _component_FormEmail = _resolveComponent("FormEmail")!
  const _component_FormPassword = _resolveComponent("FormPassword")!
  const _component_AppButtonContinue = _resolveComponent("AppButtonContinue")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading.status)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h6", null, _toDisplayString(_ctx.loading.text), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_AppInfoTitles),
    (_ctx.getters.tipoActividad === 'contacto')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.t('formDatos.titles.preDatesTitle')), 1),
          _hoisted_6
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.t('formDatos.titles.preDatesTitleTurnos')), 1),
          (
          _ctx.getters.tipoActividad === 'testdrive' ||
          _ctx.getters.tipoActividad === 'contacto' ||
          _ctx.getters.tipoActividad === 'contactovehicular'
        )
            ? (_openBlock(), _createElementBlock("h5", _hoisted_8, [
                _createTextVNode(" Si sos usuario registrado iniciá sesión. Sino te invitamos"),
                _hoisted_9,
                _createTextVNode("a registrarte o continuá como invitado ")
              ]))
            : (_ctx.getters.tipoActividad === 'recital' && _ctx.state.navigation.turno && _ctx.state.navigation.turno.vip === false)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_10, " Ingresá tu email para continuar con tu reserva "))
              : (_ctx.getters.tipoActividad === 'recital' && _ctx.state.navigation.turno && _ctx.state.navigation.turno.vip === true)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_11, [
                    _createTextVNode(" Ingreso al VIP exclusivo para clientes."),
                    _hoisted_12,
                    _createTextVNode("Si sos usuario registrado incia sesión, caso contrario te invitamos a registrarte para acceder a esta actividad ")
                  ]))
                : (_openBlock(), _createElementBlock("h5", _hoisted_13, [
                    _createTextVNode(" Actividad exclusiva para clientes."),
                    _hoisted_14,
                    _createTextVNode("Si sos usuario registrado incia sesión, caso contrario te invitamos a registrarte para acceder a esta actividad ")
                  ]))
        ], 64)),
    _createElementVNode("div", _hoisted_15, [
      (_ctx.getters.tipoActividad !== 'recital' || _ctx.state.navigation.turno && _ctx.state.navigation.turno.vip === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_component_Form, { onSubmit: _ctx.onSubmitLogin }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("h5", _hoisted_19, _toDisplayString(_ctx.t('buttons.loginButton')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_FormEmail, {
                          modelValue: _ctx.formLogin.email,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formLogin.email) = $event)),
                          fieldName: "email"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_FormPassword, {
                          modelValue: _ctx.formLogin.password,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formLogin.password) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_AppButtonContinue, {
                          text: "buttons.ingresar",
                          disabled: false
                        })
                      ]),
                      (!_ctx.getters.porInvitacion)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createVNode(_component_router_link, {
                              class: "text-center fw-bold btn button_class w-100",
                              to: { name: 'Register' }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('login.register')), 1)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_router_link, {
                        class: "nav-link text-secondary text-center fw-bold",
                        to: { name: 'Recovery' }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('restaurarPassword.title')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.getters.tipoActividad === 'testdrive' ||
          _ctx.getters.tipoActividad === 'contacto' ||
          _ctx.getters.tipoActividad === 'contactovehicular' ||
          _ctx.getters.tipoActividad === 'recital' && _ctx.state.navigation.turno && _ctx.state.navigation.turno.vip === false
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createVNode(_component_Form, { onSubmit: _ctx.onSubmitInvitado }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_30, [
                  (_ctx.getters.tipoActividad !== 'recital' || _ctx.getters.tipoActividad == 'recital' && _ctx.state.navigation.turno && _ctx.state.navigation.turno.vip === true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("h5", _hoisted_32, _toDisplayString(_ctx.t('formDatos.titles.preDatosCardTitle')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getters.tipoActividad !== 'recital' || _ctx.getters.tipoActividad == 'recital' && _ctx.state.navigation.turno && _ctx.state.navigation.turno.vip === true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.t('formDatos.titles.preDatosCardSubTitle')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_FormEmail, {
                          modelValue: _ctx.formInvitado.email,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formInvitado.email) = $event)),
                          fieldName: "email2"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["row pt-3", {'mt-5': _ctx.getters.tipoActividad !== 'recital' || _ctx.getters.tipoActividad == 'recital' && _ctx.state.navigation.turno && _ctx.state.navigation.turno.vip === true}])
                    }, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_AppButtonContinue, {
                          text: "buttons.ingresar",
                          disabled: false
                        })
                      ])
                    ], 2)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}